const getPlaylistId = (playlist) => playlist?.id || playlist?.userId || null;

export const resolveLoginPlaylist = (
  accountPlaylists = [],
  requestedPlaylist = null
) => {
  const requestedPlaylistId = getPlaylistId(requestedPlaylist);
  const matchedPlaylist = requestedPlaylistId
    ? accountPlaylists.find(
        (playlist) =>
          String(getPlaylistId(playlist)) === String(requestedPlaylistId)
      )
    : null;
  const playlist =
    matchedPlaylist || accountPlaylists[0] || requestedPlaylist || null;

  if (!playlist) return null;

  const playlistId = getPlaylistId(playlist);

  return {
    ...playlist,
    id: playlistId,
    userId: playlist.userId || playlistId,
  };
};
